import cx from "classnames";
import { ReactNode } from "react";

import { DialogBgClose } from "@/components/elements/DialogBgClose";
import useNotification from "@/hooks/useNotification";

import styles from "./styles.module.css";

export type ViewProps = {
  dismissNotification: () => void;
  children: ReactNode;
};

export const View = ({ dismissNotification, children }: ViewProps) => {
  const { position } = useNotification();
  return (
    <div className={cx(styles.container, styles[position])}>
      <DialogBgClose onClick={dismissNotification} />
      <div className={styles.notification} id="notification">
        <div className={styles.inner}>{children}</div>
      </div>
    </div>
  );
};
